import file_upload from './file_upload.js'

export default {
  file_upload
}
